import toLowerCase from './toLowerCase';

export function parseErrors(errorsData:any): any {
    const errorObj = {};
    for (const [key, value] of (Object as any).entries(errorsData)) {
        errorObj[toLowerCase(key)] = value;
    }
    return errorObj;
}

export interface IFormError{
    key:string;
    value: string[]
}
